import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

class LedgerApi {
    constructor() {
        this.baseUrl = 'api/inventory-ledger/v1';
    }

    async getGroupBySkuData(facilityId, pageNumber = 0, pageSize = 50, queryParams = '') {
        const paginationParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
        const url = `${this.baseUrl}/summary/sku?facilityId=${facilityId}&${paginationParams}${
            queryParams ? `&${queryParams}` : ''
        }`;
        const response = await mmFetchWithResponse(url);

        // Add pagination metadata to the response
        if (response.status && response.data) {
            response.data.meta = {
                ...response.data.meta,
                hasMore: response.data.meta?.hasMore ?? response.data.rows.length >= pageSize,
            };
        }

        return response;
    }

    async getGroupByLotData(facilityId, pageNumber = 0, pageSize = 50, queryParams = '') {
        const paginationParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
        const url = `${this.baseUrl}/summary/lot?facilityId=${facilityId}&${paginationParams}${
            queryParams ? `&${queryParams}` : ''
        }`;
        const response = await mmFetchWithResponse(url);

        // Add pagination metadata to the response
        if (response.status && response.data) {
            response.data.meta = {
                ...response.data.meta,
                hasMore: response.data.meta?.hasMore ?? response.data.rows.length >= pageSize,
            };
        }

        return response;
    }

    async getEventHistory(type, skuOrLotId, facilityId, queryParams, pageNumber = 0, pageSize = 50) {
        let skuOrLotParam = '';
        if (type === 'sku') {
            skuOrLotParam = `&sku=${skuOrLotId}`;
        } else if (type === 'lot') {
            skuOrLotParam = `&lot=${skuOrLotId}`;
        }
        const paginationParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
        const url = `${this.baseUrl}/events?facilityId=${facilityId}${skuOrLotParam}${
            queryParams ? `&${queryParams}` : ''
        }&${paginationParams}`;
        const response = await mmFetchWithResponse(url);

        // Ensure response.data.events exists and is an array
        if (response.status && response.data) {
            response.data.events = response.data.events || [];
            response.data.meta = {
                ...response.data.meta,
                hasMore: response.data.meta?.hasMore ?? response.data.events.length >= pageSize,
            };
        }

        return response;
    }

    async exportEventCSV(type, skuOrLotId, facilityId, queryParams = '') {
        let skuOrLotParam = '';
        if (type === 'sku') {
            skuOrLotParam = `&sku=${skuOrLotId}`;
        } else if (type === 'lot') {
            skuOrLotParam = `&lot=${skuOrLotId}`;
        }
        const url = `${this.baseUrl}/events/export?facilityId=${facilityId}${skuOrLotParam}${
            queryParams ? `&${queryParams}` : ''
        }`;

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                return res;
            }
            throw new Error('Failed to download CSV');
        } catch (e) {
            console.error('[exportEventCSV] error', e.toString());
            throw e;
        }
    }

    async getAdjustmentsAsReasons(type, skuOrLotId, facilityId, queryParams = '') {
        const endpoint = type === 'lot' ? 'reasons/lot' : 'reasons/sku';

        const paramKey = type === 'sku' ? 'sku' : 'lot';

        const url = `${this.baseUrl}/${endpoint}?facilityId=${facilityId}&${paramKey}=${skuOrLotId}${
            queryParams ? `&${queryParams}` : ''
        }`;

        return mmFetchWithResponse(url);
    }
}

export { LedgerApi };
